import { observer } from 'mobx-react-lite';
import { Outlet } from 'react-router';
import { twMerge } from 'tailwind-merge';
import { ModalContainer } from '../views/common/modal/Modal';
import { ToastContainer } from '../views/common/toast/ToastContainer';
import ListeningSidebar from './ListeningSidebar';
import { useEffect } from 'react';
import firebaseStore from '../stores/firebaseStore';
import { useCommonNavigate } from '../views/common/CommonLink';
import _ from 'lodash';

const ListeningLayout = observer(() => {
    const { navigate } = useCommonNavigate();

    useEffect(() => {
        if (firebaseStore.isInitialized && !firebaseStore.me) {
            // 로그아웃 모달이 닫히고 난 후에 이동하도록 딜레이를 줌
            _.delay(() => {
                navigate('/');
            }, 500);
        }
    }, [firebaseStore.isInitialized, firebaseStore.me]);

    return (
        <>
            <div className="flex h-dvh overflow-hidden">
                {/* 사이드바 */}
                <div className={twMerge('shrink-0 overflow-hidden')}>
                    <ListeningSidebar />
                </div>
                {/* 메인 컨텐츠 영역 */}
                <div
                    className={twMerge(
                        'flex min-w-0 flex-1 flex-col',
                        // 스크롤 바운싱 되는 동작을 막기 위해 메인 영역을 최대 높이로 제한하고, 엘리먼트 스크롤을 적용함
                        // overscroll-none: 스크롤 바운싱 되는 동작을 막기 위해 사용. 부모로 스크롤이 전파되는 것을 차단
                        'h-dvh overflow-scroll overscroll-none',
                        '[--listening-header-height:48px]',
                        'lg:[--listening-header-height:96px]',
                    )}
                >
                    <div
                        // 여기에 ListeningHeader 를 포털로 렌더링함
                        id="listening-header"
                        className={twMerge('sticky top-0 z-(--z-index-navbar) w-full')}
                    ></div>
                    <main className={twMerge('flex-1')}>
                        <Outlet />
                    </main>
                </div>
            </div>
            <ModalContainer />
            <ToastContainer />
        </>
    );
});

export default ListeningLayout;
